import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { type Tag } from 'entities/Tags/model/Tag'
import { TagCard } from 'entities/Tags'
import styles from './styles.module.scss'

type IActionTagsProps = {
  name: string
  placeholder: string
  futureTags?: Promise<Tag[]>
}

export const ActionTags = observer(({ name, placeholder, futureTags }: IActionTagsProps) => {
  const [tags, setTags] = useState<Tag[]>([])
  const [tagsReady, setTagsReady] = useState(false)

  useEffect(() => {
    if (!futureTags) {
      setTagsReady(true)
      return
    }

    setTagsReady(false)
    futureTags.then((tags) => {
      setTags(tags)
      setTagsReady(true)
    })
  }, [futureTags])

  return (
    <div className={styles.actionRow}>
      <Typography ariaLabel={'actionName'} variant={'text-input-field-r'} className={styles.name}>
        {name}
      </Typography>
      {tagsReady &&
        (tags.length ? (
          <div className={styles.tags}>
            {tags.map((tag) => (
              <TagCard key={tag.id} tag={tag} />
            ))}
          </div>
        ) : (
          <Typography
            ariaLabel={'actionValue'}
            variant={'body-md-regular'}
            className={styles.value}
          >
            <span className={styles.placeholder}>{placeholder}</span>
          </Typography>
        ))}
    </div>
  )
})
